import { lightColors } from '@/plugins/colors/base/baseColorsLight'

const alertTokensLight = {
  'alert-warning-background': lightColors.orange['50'],
  'alert-warning-border': lightColors.orange['100'],
  'alert-warning-foreground': lightColors.orange['700'],
  'alert-warning-icon': lightColors.orange['500'],
  'alert-warning-close': lightColors.orange['700'],
  'alert-success-background': lightColors.green['50'],
  'alert-success-border': lightColors.green['100'],
  'alert-success-foreground': lightColors.green['700'],
  'alert-success-icon': lightColors.green['500'],
  'alert-success-close': lightColors.green['700'],
  'alert-info-background': lightColors.blue['50'],
  'alert-info-border': lightColors.blue['100'],
  'alert-info-foreground': lightColors.blue['700'],
  'alert-info-icon': lightColors.blue['500'],
  'alert-info-close': lightColors.blue['700'],
  'alert-error-background': lightColors.red['50'],
  'alert-error-border': lightColors.red['100'],
  'alert-error-foreground': lightColors.red['700'],
  'alert-error-icon': lightColors.red['500'],
  'alert-error-close': lightColors.red['700']
}

export default alertTokensLight
